"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherRegionsSwiper = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
var _Slide = require("./components/Slide");
var _localization = require("@lt/localization");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OtherRegionsSwiper = exports.OtherRegionsSwiper = function OtherRegionsSwiper(_ref) {
  var countryName = _ref.countryName,
    regions = _ref.regions,
    onChange = _ref.onChange,
    isHotelOnly = _ref.isHotelOnly,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var _useState = (0, _react.useState)(regions[0]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeRegion = _useState2[0],
    setActiveRegion = _useState2[1];
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var clickSlide = function clickSlide(region) {
    setActiveRegion(region);
    onChange(region);
  };
  var offerType = isHotelOnly ? t('search.otherRegionOffer.hotelOfferType') : t('search.otherRegionOffer.packageOfferType');
  return /*#__PURE__*/_react["default"].createElement(_styles.StyledContainer, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_styles.Header, {
    $isMobile: isMobile
  }, t('search.otherRegionOffer.header', {
    offerType: offerType,
    countryName: countryName
  })), /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"]
  /* @ts-ignore */, {
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    freeMode: true,
    mousewheel: {
      enabled: true
    },
    navigation: isMobile ? false : {
      nextEl: '.swiper-button-custom-next',
      prevEl: '.swiper-button-custom-prev'
    },
    renderPrevButton: function renderPrevButton() {
      return /*#__PURE__*/_react["default"].createElement(_styles.StyledNavigationButton, {
        className: "swiper-button-custom-prev",
        type: "prev"
      });
    },
    renderNextButton: function renderNextButton() {
      return /*#__PURE__*/_react["default"].createElement(_styles.StyledNavigationButton, {
        className: "swiper-button-custom-next",
        type: "next"
      });
    }
  }, regions.map(function (region) {
    return /*#__PURE__*/_react["default"].createElement(_Slide.Slide, {
      region: region,
      key: "slide_".concat(region.id),
      onClick: clickSlide,
      isActive: activeRegion.id === region.id,
      isMobile: isMobile
    });
  })));
};